module.exports = __webpack_public_path__ + "static/wp-161acf1deb9b8a0ef414da5aaeb77571.png";